import React, { useCallback, useEffect, useState } from 'react';
import { Sidebar } from './Sidebar';
import { SentimentCard } from './SentimentCard';
import { DealPossibilitiesCard } from './DealPossibilitiesCard';
import { CallReviewCard } from './CallReviewCard';
import { ObjectionHandlingCard } from './ObjectionHandlingCard';
import { BehaviorAnalysisCard } from './BehaviorAnalysisCard';
import { MissedItemsCard } from './MissedItemsCard';
import { ActionItemsCard } from './ActionItemsCard';
import { FollowUpCard } from './FollowUpCard';
import { CommandPalette } from './CommandPalette';
import { PrintReport } from './PrintReport';
import { Search, ArrowLeft, Printer } from 'lucide-react';
export function CallAnalysisDashboard() {
  const [activeSection, setActiveSection] = useState<string | null>(null);
  const [isPaletteOpen, setIsPaletteOpen] = useState(false);
  const [isPrintMode, setIsPrintMode] = useState(false);
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        setIsPaletteOpen(prev => !prev);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);
  const handleNavigate = useCallback((section: string) => {
    const el = document.getElementById(section);
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
    setActiveSection(section);
    setTimeout(() => setActiveSection(null), 2000);
  }, []);
  const handlePrint = useCallback(() => {
    setIsPrintMode(true);
    setTimeout(() => {
      window.print();
    }, 100);
  }, []);
  if (isPrintMode) {
    return <div className="min-h-screen bg-gray-200 py-8 px-4" data-id="element-39">
        <div className="max-w-4xl mx-auto mb-6 no-print flex justify-between items-center" data-id="element-40">
          <button onClick={() => setIsPrintMode(false)} className="flex items-center gap-2 text-gray-600 hover:text-navy font-medium bg-white px-4 py-2 rounded-lg shadow-sm transition-colors" data-id="element-41">
            <ArrowLeft size={16} data-id="element-42" />
            Back to Dashboard
          </button>
          <button onClick={() => window.print()} className="flex items-center gap-2 text-white bg-crimson hover:bg-crimson-dark font-medium px-4 py-2 rounded-lg shadow-sm transition-colors" data-id="element-43">
            <Printer size={16} data-id="element-44" />
            Print Now
          </button>
        </div>
        <div className="shadow-2xl print:shadow-none" data-id="element-45">
          <PrintReport data-id="element-46" />
        </div>
      </div>;
  }
  return <div className="min-h-screen bg-gray-50 flex flex-col lg:flex-row" data-id="element-47">
      <Sidebar onNavigate={handleNavigate} activeSection={activeSection} onPrint={handlePrint} data-id="element-48" />

      <main className="flex-1 lg:ml-[280px] p-4 md:p-8 lg:p-12 relative" data-id="element-49">
        <div className="max-w-4xl mx-auto space-y-8" data-id="element-50">
          <div id="sentiment" data-id="element-51">
            <SentimentCard highlighted={activeSection === 'sentiment'} data-id="element-52" />
          </div>
          <div id="deal" data-id="element-53">
            <DealPossibilitiesCard highlighted={activeSection === 'deal'} data-id="element-54" />
          </div>
          <div id="callReview" data-id="element-55">
            <CallReviewCard highlighted={activeSection === 'callReview'} data-id="element-56" />
          </div>
          <div id="objections" data-id="element-57">
            <ObjectionHandlingCard highlighted={activeSection === 'objections'} data-id="element-58" />
          </div>
          <div id="behavior" data-id="element-59">
            <BehaviorAnalysisCard highlighted={activeSection === 'behavior'} data-id="element-60" />
          </div>
          <div id="missed" data-id="element-61">
            <MissedItemsCard highlighted={activeSection === 'missed'} data-id="element-62" />
          </div>
          <div id="action" data-id="element-63">
            <ActionItemsCard highlighted={activeSection === 'action'} data-id="element-64" />
          </div>
          <div id="followUp" data-id="element-65">
            <FollowUpCard highlighted={activeSection === 'followUp'} data-id="element-66" />
          </div>
        </div>
      </main>

      <CommandPalette isOpen={isPaletteOpen} onClose={() => setIsPaletteOpen(false)} onNavigate={handleNavigate} data-id="element-67" />

      <button onClick={() => setIsPaletteOpen(true)} className="fixed bottom-6 right-6 lg:bottom-10 lg:right-10 w-14 h-14 bg-crimson text-white rounded-full shadow-lg hover:shadow-xl hover:bg-crimson-dark transition-all flex items-center justify-center z-40 focus:outline-none focus:ring-4 focus:ring-crimson/30" aria-label="Open command palette" data-id="element-68">
        <Search size={24} data-id="element-69" />
      </button>
    </div>;
}